<template>
  <div v-show="needRefresh" class="container m-t-10">
    <div class="alert alert-warning" role="alert">
      <p>
        {{ $i18n.t('version.outdated.first') }}
        <a href="#" @click.prevent="hardRefresh">{{ $i18n.t('version.outdated.link') }}</a>
        {{ $i18n.t('version.outdated.second') }}
      </p>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'

export default{
  computed: {
    ...mapGetters({
      isUpToDate: 'version/isUpToDate',
      isNewAvailable: 'version/isNewAvailable'
    }),
    needRefresh() {
      return !this.isUpToDate && this.isNewAvailable
    }
  },
  methods: {
    hardRefresh() {
      location.reload(true);
    },

  }
}
</script>

<style scoped>
  p {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/VersionOutdated.vue